var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-google"},[_c('FontAwesomeIcon',{attrs:{"icon":['fab', 'google']}}),_vm._v(" Sign in with Google ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }